import axios from 'axios'

var Installation = {
  api_base: (process.env.NODE_ENV === 'development' ? 'http://localhost:8083/api/onapi/' : '/api/onapi/'),
  collapsegui: '768',
  loadSettings: async function () {
    var loaded = false
    await axios.request({
      url: this.api_base + 'settings',
      method: 'get'
    }).then(res => {
      Object.assign(Installation, res.data)
      loaded = true
    }).catch(err => {
      loaded = false
    })
    return loaded
  }
}

module.exports = Installation



// WEBPACK FOOTER //
// ./src/projects/access-gui/config/installation.js